import React from "react";
import { Grid } from "@material-ui/core";
import { Images } from "config/images";

export default function RefreshLoading() {
	return (
		<Grid container justifyContent="center" style={{ padding: 35 }}>
			<img
				src={Images.icLoadding}
				alt="icLoadding"
				style={{ width: 30, height: 30 }}
			/>
		</Grid>
	);
}
